// src/components/SharePointSearch/sharepointSearchStyles.ts
// Shared color tokens and style definitions for SharePointSearch components

import React from "react";

export const spColors = {
  teal: "#038387",
  tealBg: "rgba(3, 131, 135, 0.1)",
  tealBorder: "rgba(3, 131, 135, 0.3)",
  mutedBg: "#F8F9FA",
  mutedBgHover: "#E9ECEF",
  border: "#E9ECEF",
  foreground: "#1a1a1a",
  mutedForeground: "#6C757D",
  headerText: "#495057",
  separator: "#CED4DA",
  warningBg: "rgba(255, 193, 7, 0.1)",
  warningColor: "#856404",
  errorBg: "rgba(220, 53, 69, 0.08)",
  errorColor: "#721c24",
  quoteBg: "rgba(3, 131, 135, 0.03)",
};

export const FILE_TYPE_COLORS: Record<string, string> = {
  docx: "#2B579A",
  pdf: "#D13438",
  default: "#6C757D",
};

export const containerStyle: React.CSSProperties = {
  marginBottom: "12px",
  overflow: "hidden",
  width: "100%",
  minWidth: 0,
};

export const createHeaderStyle = (isExpanded: boolean): React.CSSProperties => ({
  boxSizing: "border-box" as const,
  display: "flex",
  alignItems: "center",
  gap: "12px",
  padding: "12px 16px",
  backgroundColor: spColors.mutedBg,
  border: `1px solid ${spColors.border}`,
  borderRadius: isExpanded ? "8px 8px 0 0" : "8px",
  cursor: "pointer",
  textAlign: "left" as const,
  transition: "background-color 0.2s ease",
  fontFamily: "'Segoe UI', sans-serif",
  userSelect: "none" as const,
});

export const textContentStyle: React.CSSProperties = {
  flex: 1,
  minWidth: 0,
  overflow: "hidden",
};

export const headerTextStyle: React.CSSProperties = {
  fontSize: "13px",
  lineHeight: "1.4",
  color: spColors.headerText,
  fontWeight: 500,
  margin: 0,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap" as const,
};

export const separatorStyle: React.CSSProperties = {
  color: spColors.separator,
  margin: "0 6px",
};

export const summaryTextStyle: React.CSSProperties = {
  fontStyle: "italic",
};

export const createCollapseWrapperStyle = (isExpanded: boolean): React.CSSProperties => ({
  maxHeight: isExpanded ? "500px" : "0",
  overflow: "hidden",
  transition: "max-height 0.3s ease",
});

export const createExpandedContentStyle = (isExpanded: boolean): React.CSSProperties => ({
  backgroundColor: "#FFFFFF",
  borderLeft: isExpanded ? `1px solid ${spColors.border}` : "none",
  borderRight: isExpanded ? `1px solid ${spColors.border}` : "none",
  borderBottom: isExpanded ? `1px solid ${spColors.border}` : "none",
  borderRadius: isExpanded ? "0 0 8px 8px" : "0",
});

export const contentAreaStyle: React.CSSProperties = {
  padding: "16px",
  maxHeight: "400px",
  overflowY: "auto" as const,
  overflowX: "hidden" as const,
};
